module.exports = {
    status: "initialize",
    loadingError: null,
    questions: [],
    jobInfo_status: "initialize",
    jobInfo: null,
}